import { useTranslation } from "react-i18next"

import img from "../../assets/404.png"
import LinkButton from "../LinkButton/LinkButton"
import Image from "../image/Image"

import styles from "./Error404.module.scss"

const Error404 = () => {
  const { i18n, t } = useTranslation()

  return (
    <div className={styles.error404Container}>
      <div className={styles.textCointainer}>
        <Image className={styles.image} images={[img]} alt="" />
        <h1 className={styles.title}>{t("404 title")}</h1>
        <h2 className={styles.subtitle}>{t("404 subtitle")}</h2>
        <div className={styles.button}>
          <LinkButton
            to={`/${i18n.language}`}
            children={t("Go to home page")}
          />
        </div>
      </div>
    </div>
  )
}

export default Error404
